module.exports = __webpack_public_path__ + "img/qr-code_MENUPOLY_TS.6db3ca21.png";